import * as React from 'react';

function SvgReconciliationEditIcon(props) {
  return (
    <svg width={15} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.693 10.748a.63.63 0 00.094-.007l2.628-.461a.153.153 0 00.083-.044l6.623-6.623a.155.155 0 000-.22l-2.597-2.6a.155.155 0 00-.11-.044.155.155 0 00-.112.045L3.68 7.417a.159.159 0 00-.044.083l-.46 2.628a.524.524 0 00.146.466.53.53 0 00.372.155zm1.053-2.724l5.667-5.666 1.146 1.145L5.892 9.17l-1.39.245.244-1.39zm8.67 4.037h-11.5a.5.5 0 00-.5.5v.563c0 .068.057.124.126.124h12.25a.125.125 0 00.124-.124v-.563a.5.5 0 00-.5-.5z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgReconciliationEditIcon;
